import React, { ComponentType, Fragment } from 'react'
import { NoMeetingResult } from './NoMeetingResult'
import { AiFeature } from '../../../../../../../models/AiFeature'
import { AiResult, StructuredSummaryResultType } from '../../../../../../../models/AiResult'
import { StructuredSummaryMeetingResultView } from './StructuredSummaryMeetingResultView'
import { TextMeetingResultProps } from './TextMeetingResult'
import './ListMeetingResults.scss'
import { getSafeValueOnPath } from '../../../utils'

interface ListMeetingResultProps {
  aiFeature: AiFeature
  aiResult: AiResult
  basePath: string
  path: string
  className?: string
  onFormattedResultChange: (basePath: string, path: string, contentType: string, content: string) => void
  parentHasMapValue?: boolean
  CustomTextMeetingResult?: ComponentType<TextMeetingResultProps>
}

export const ListMeetingResult: React.FC<ListMeetingResultProps> = ({
  aiFeature,
  aiResult,
  basePath,
  path,
  onFormattedResultChange,
  className = '',
  parentHasMapValue,
  CustomTextMeetingResult,
}) => {
  const results: StructuredSummaryResultType[] = getSafeValueOnPath(getSafeValueOnPath(aiResult.result, basePath), path, []) ?? []

  if (!results.length) {
    return <NoMeetingResult />
  }

  const hasObjectResult = results.some((result) => !Array.isArray(result) && typeof result === 'object')

  return (
    <div className='d-flex flex-column gap-1'>
      {results.map((_, idx) => {
        const childPath = `${path}[${idx}]`
        const lastChild = idx === results.length - 1
        return (
          <Fragment key={childPath}>
            <StructuredSummaryMeetingResultView
              aiResult={aiResult}
              aiFeature={aiFeature}
              basePath={basePath}
              path={childPath}
              className={className}
              onFormattedResultChange={onFormattedResultChange}
              parentHasMapValue={parentHasMapValue}
              displayAsList
              CustomTextMeetingResult={CustomTextMeetingResult}
            />
            {!lastChild && hasObjectResult && <div className='list-meeting-result-separator mt-2 mb-3' />}
          </Fragment>
        )
      })}
    </div>
  )
}
